// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bPnOS","question":"styles_question__3l6Nc","inputVisibleButton":"styles_inputVisibleButton__3ccQj","note":"styles_note__AP7nG"};